import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Register from '../register/';
import Login from '../login/';
import LoadingDialog from '../loadingModal/';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={'span'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

function Auth(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [showLoading, setLoading] = React.useState(false);
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };

  return (
    <div className="container justify-center" style={{ maxWidth: '900px' }}>
      <div
        className={classes.root}
        style={{
          borderTopLeftRadius: '25px',
          borderTopRightRadius: '25px',
        }}
      >
        <AppBar
          position="static"
          color="default"
          style={{
            borderTopLeftRadius: '25px',
            borderTopRightRadius: '25px',
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="standard"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
            centered
          >
            <Tab label="CADASTRAR" {...a11yProps(0)} />
            <Tab label="ENTRAR" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
          
        >
          <TabPanel value={value} index={0}>
            <Register setLoading={setLoading} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Login
              setLoading={setLoading}
              userLogin={props.userLogin}
              resetPassword={props.resetPassword}
            />
          </TabPanel>
        </SwipeableViews>
        <LoadingDialog isLoading={showLoading}></LoadingDialog>
      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch, { history }) {
  return {
    // _fillSource: (text, source) => dispatch(fillSelects(text, source,)),
  };
}

export default connect(mapDispatchToProps)(Auth);
